export interface IPodcastResponseSoa {
  value: IPodcastValue;
  errors: any[];
  success: boolean;
}

export interface IPodcastValue {
  id: string;
  name: string;
  description: string;
  organization: IPodcastOrganization;
  hosts: IPodcastHost[];
  rating: number;
  follow: boolean;
  hasResources: boolean;
  imageUrl: string;
  episodes: IPodcastEpisodes;
}

export interface IPodcastOrganization {
  published: boolean;
  id: string;
  value: string;
}

export interface IPodcastHost {
  id: string;
  fullName: string;
  publish: boolean;
  avatarUrl: string;
}

export interface IPodcastEpisodes {
  pages: number;
  total: number;
  items: IPodcastEpisodeItem[];
}

export interface IPodcastEpisodeItem {
  id: string;
  name: string;
  description: string;
  duration: string;
  url: string;
  consumption: number | null;
  playing?: boolean;
}
